import { formatRawAppointments } from './appointment-mapper';
import { extractApptFilterOptions } from './appointment-filter-mapper';
import { applyFilter } from './appointment-filter-logic';
import { sortAppointments } from './appointment-sorter';

export const APPTS_LOCAL_STORAGE_KEY = 'patient:appointments';


export const setAppointments = (appointments) => (state) =>
  ({ ...state, appointments });

export const mapAppointments = (appointments, upcoming) => (state) => {
  const mappedAppointments = formatRawAppointments(appointments);
  const extractedFilterOptions = extractApptFilterOptions(mappedAppointments);
  const newState = {

    ...state,
    ...(upcoming ? { upcomingAppointments: mappedAppointments } : { appointments: mappedAppointments }),
    unfilteredCount: mappedAppointments.length,
    filterOptions: extractedFilterOptions,
  };

  return newState;
};

export const setDateFilterPreference = (filter) => (state) => {
  if (!filter || filter.length < 1) {
    return state;
  }

  return { filter: { ...state.filter, date: filter[0].value } };
};

export const setAppointmentsFilter = (filter) => (state) => {
  const newFilter = { ...state.filter, ...filter };
  const filtered = applyFilter(newFilter, state.appointments);
  return {

    ...state,
    filter: newFilter,
    appointments: filtered };
};

export const sortPatientAppointments = (sortOption) => (state) => {
  const sorted = sortAppointments(state.appointments, sortOption);
  return {

    ...state,
    appointments: sorted };
};

export const toggleFilters = (show) => (state) =>
  ({ ...state, showFilterPanel: show });
